export default __webpack_public_path__ + "static/media/yggdrasil-mono.34e16d9f.svg";